var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometerOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0475 27.5256C12.4125 28.8419 14.0633 29.5 16 29.5C17.9367 29.5 19.5875 28.8419 20.9525 27.5256C22.3175 26.2094 23 24.6175 23 22.75C23 21.67 22.755 20.6631 22.265 19.7294C21.775 18.7956 21.0867 18.0025 20.2 17.35V6.55C20.2 5.425 19.7917 4.46875 18.975 3.68125C18.1583 2.89375 17.1667 2.5 16 2.5C14.8333 2.5 13.8417 2.89375 13.025 3.68125C12.2083 4.46875 11.8 5.425 11.8 6.55V17.35C10.9133 18.0025 10.225 18.7956 9.735 19.7294C9.245 20.6631 9 21.67 9 22.75C9 24.6175 9.6825 26.2094 11.0475 27.5256ZM16.9975 5.58813C17.2658 5.84688 17.4 6.1675 17.4 6.55V7.9H16V9.25H17.4V11.95H16V13.3H17.4V16H16V17.35H17.4V18.9305C19.0313 19.4864 20.2 20.9866 20.2 22.75C20.2 24.9868 18.3196 26.8 16 26.8C13.6804 26.8 11.8 24.9868 11.8 22.75C11.8 20.9866 12.9687 19.4864 14.6 18.9305V6.55C14.6 6.1675 14.7342 5.84688 15.0025 5.58813C15.036 5.55578 15.0706 5.52546 15.1061 5.49716C15.355 5.29905 15.6529 5.2 16 5.2C16.3967 5.2 16.7292 5.32938 16.9975 5.58813Z",
    fill: "white",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerOutlined);
export default __webpack_public_path__ + "static/media/thermometer_outlined.31240873a0b1c98a4271ca1fea93f3d9.svg";
export { ForwardRef as ReactComponent };